module.exports = __webpack_public_path__ + "img/dreamer.fe5645e1.png";